<template>
    <div class="tickets-page tickets-table">
        <div class="group-header group-header--tickets">
            <div class="group-header__details">
                <i
                    class="icon--sm tickets-table__header-icon"
                    :class="headerIcon"
                >
                </i>
                {{ $t(title) }}
            </div>
        </div>
        <div class="details-header">
            <div
                v-for="header in headers"
                :key="header.title"
                :class="['details-header__event-collection', header.className]"
            >
                {{ $t(header.title) }}
            </div>
        </div>
        <Accordion
            :contentLoadingData="{ isContentLoaded: !areResultsLoading }"
            @expand="onExpand"
        >
            <AccordionItem
                v-for="ticket in tickets"
                :key="ticket.id"
            >
                <template
                    slot="title"
                    :is="rowComponent"
                    v-bind="ticket"
                    :stake="ticket.payment.stake"
                    :potentialWin="ticket.win.estimated"
                    :payoff="ticket.win.payoff"
                    class="tickets-row"
                />
                <template slot="content" >
                    <MatchesContainer
                        v-if="ticket.type === TicketType.sport"
                        :areResultsLoading="areResultsLoading"
                        :events="ticket.events"
                        :resultsMap="resultsMap"
                        :system="ticket.system"
                    />
                    <LottoEventWidget
                        v-else
                        :events="ticket.events"
                        :system="ticket.system"
                    />
                </template>
            </AccordionItem>
            <div
                v-if="tickets && tickets.length < 1"
                class="tickets-table__empty-state"
            >
                <Illustration image="/static/img/illustrations/ticket__empty-state.svg"/>
                <div class="tickets-table__empty-state-message">
                    {{ $t('Currently you have no active bets') }}
                </div>
            </div>
        </Accordion>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { isSpecialEvent } from '@core/models/specials/SpecialEvent';
    import { TicketType } from '@core/models/tickets/enums';
    import ActiveTicketRow from './ActiveTicketRow';
    import ResolvedTicketRow from './ResolvedTicketRow';
    import MatchesContainer from './sport/MatchesContainer';
    import LottoEventWidget from './lotto/LottoEventWidget';

    export default {
        created() {
            this.TicketType = TicketType;
        },
        data() {
            return {
                areResultsLoading: true,
                resultsMap: {},
            };
        },
        props: {
            headerIcon: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            tickets: {
                type: Array,
                required: true,
            },
            headers: {
                type: Array,
                required: true,
            },
            rowComponent: {
                type: String,
                required: true,
            },
        },
        methods: {
            ...mapActions('data/results/sport', [
                'fetchSportResultsById'
            ]),
            async onExpand(rowIndex) {
                const ticket = this.tickets[rowIndex];
                this.areResultsLoading = true;
                const results = {};

                if (ticket.type === TicketType.sport) {
                    const matches = ticket.events.map((t) => t.eventId)
                        .filter((eventId) => !isSpecialEvent(eventId, 'S'));
                    const matchResults = await this.fetchSportResultsById(matches);
                    matchResults.forEach((match) => {
                        results[match.id] = match.matchResults;
                    });
                }
                this.resultsMap = results;
                this.areResultsLoading = false;
            },
        },
        components: {
            MatchesContainer,
            LottoEventWidget,
            /* eslint-disable vue/no-unused-components */
            ActiveTicketRow,
            ResolvedTicketRow,
            /* eslint-enable vue/no-unused-components */
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/tickets/components/TicketsTable.vue